import getItems from './getItems'
import getForm from './getForm'
import saveState from './saveState'
import saveComment from './saveComment';
import sendRemindersOnb from './sendRemindersOnb';
import deleteDeclarations from './deleteDeclarations';
import getFicha from './getFicha';

export const getItemsPromise = getItems;
export const getFormPromise = getForm;
export const saveStatePromise = saveState;
export const saveCommentsPromise = saveComment;
export const sendRemindersOnbPromise = sendRemindersOnb;
export const deleteDeclarationsPromise = deleteDeclarations;
export const getFichaPromise = getFicha;
